import { atom } from 'jotai';
import { createRequestAtom } from '../../../../shared/utils/request-atom';
import { CustomFields, CustomFieldsData } from '../typings';
import { CustomFieldUpdatePayload } from '../components/chat-list-section/chat-row/typings';

export const customFieldsAtom = createRequestAtom<CustomFieldsData | undefined>();

export const updatedCustomFieldEventAtom = atom<CustomFieldUpdatePayload | undefined>(undefined);

// Atom to trigger lead-status refresh when custom fields are updated
export const refreshLeadsAtom = atom<number>(0);
